import { render } from "./Complex.vue?vue&type=template&id=348b4cf5&lang=pug"
import script from "./Complex.vue?vue&type=script&lang=ts"
export * from "./Complex.vue?vue&type=script&lang=ts"

import "./Complex.vue?vue&type=style&index=0&id=348b4cf5&lang=scss"
script.render = render

export default script